import { useState } from 'react';
import {
  Tabs,
  Tab,
  Box,
  Button,
  TextField,
  Snackbar,
  IconButton,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import useAuthContext from '../auth/useAuthContext';
import '../styles.css';
import config from '../config/index';

function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [cpass, setCpass] = useState(''); // state for confirm password
  const [showPassword, setShowPassword] = useState(false); // new state variable
  const {
    user, login, signing, forgotPwd, changePwd, error, confirmsignupp, resendSignUp,
  } = useAuthContext();
  const [tabIndex, setTabIndex] = useState(0); // this is for tab index to switch from login to signup
  const [stage, setStage] = useState(1); // used for password recovery form 1=email stage 2=code stage
  const [code, setCode] = useState('');
  const [upstage, setUpstage] = useState(1); // USED FOR SIGNUP VERIFICATION 1 FOR EMAIL PWD 2 FOR CODE
  const [signupcode, setSignupcode] = useState('');

  const handleTabChange = (event, newTabIndex) => {
    // it will change the index of tab to switch from login to signup
    setTabIndex(newTabIndex);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    login(email, password);
  };

  const handleresendsignup = async (event) => {
    event.preventDefault();
    resendSignUp(email);
  };

  const handleSubmitsignup = async (event) => {
    event.preventDefault();
    signing(email, password);
    setUpstage(2);
  };

  const handleconfirmsignup = async (event) => {
    event.preventDefault();
    confirmsignupp(email, signupcode);
  };
  const sendCode = async (event) => {
    event.preventDefault();
    setStage(2);
    forgotPwd(email);
  };

  const resetPassword = async (event) => {
    event.preventDefault();
    changePwd(email, code, password)
      .then((data) => console.log(data))
      .catch((err) => console.log(err));
  };

  const signupshow = config.enableSelfSignup;

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const isEdgeBrowser = navigator.userAgent.indexOf('Edg') > -1;

  return (
    <div style={{ height: '100vh' }}>
      <Box
        display='flex'
        flexDirection='column'
        maxWidth={800}
        alignItems='center'
        justifyContent='center'
        margin='auto' // to make it to the center from left and right
        marginTop={5}
        padding={3}
        borderRadius={5}
        boxShadow='5px 5px 10px #ccc'
        sx={{
          ':hover': {
            boxShadow: '10px 10px 20px #ccc',
          },
          // backgroundColor: 'blue' ,
          height: '800px',
        }} // SX IS USED TO ADD CUSTOM CSS
      >
        <Snackbar
          open={!!error}
          autoHideDuration={5000}
          message={error}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        />

        {/* here i have created tabs to switch between each other */}
        {/* https://codingbeautydev.com/blog/material-ui-tabs/ */}
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label='Login' />
          {signupshow ? <Tab label='Signup' /> : null}
          <Tab label='Forget password?' />
        </Tabs>
        {tabIndex === 0 && ( // tab for login begin here
          <Box>
            <h1 style={{ fontSize: 50 }}>
              {user ? `User: ${user.attributes?.email}` : 'Sign In'}
            </h1>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                // size='small'
                label='Email'
                value={email}
                autoComplete='username'
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined'
                // size='small'
                label='Password'
                type={showPassword ? 'text' : 'password'}
                value={password}
                autoComplete='current-password'
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    (!isEdgeBrowser && (
                      <IconButton onClick={handleShowPassword} aria-label='Toggle password visibility'>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ))
                  ),
                }}
              />
              {/* <input type='submit' value='Login'/> */}
              <Button
                type='submit'
                variant='contained'
                sx={{ mt: 3, mb: 2, borderRadius: 3 }}
              >
                Login
              </Button>
            </form>
          </Box>
        )}
        { signupshow && tabIndex === 1 && upstage === 1 && ( // tab for signup begin here
          <Box>
            <h1 style={{ fontSize: 50 }}>
              {user ? `User: ${user.attributes.email}` : 'Sign Up'}
            </h1>
            <form onSubmit={handleSubmitsignup}>
              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                // size='small'
                label='Email'
                value={email}
                autoComplete='username'
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined'
                // size='small'
                label='Password'
                type={showPassword ? 'text' : 'password'}
                value={password}
                autoComplete='current-password'
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    (!isEdgeBrowser && (
                      <IconButton onClick={handleShowPassword} aria-label='Toggle password visibility'>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ))
                  ),
                }}
              />
              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined'
                // size='small'
                label=' Confirm Password'
                type={showPassword ? 'text' : 'password'}
                value={cpass}
                autoComplete='current-password'
                onChange={(e) => setCpass(e.target.value)}
                InputProps={{
                  endAdornment: (
                    (!isEdgeBrowser && (
                      <IconButton onClick={handleShowPassword} aria-label='Toggle password visibility'>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ))
                  ),
                }}
              />
              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                // size='small'
                label='Name'
                value={name}
                autoComplete='Name'
                onChange={(e) => setName(e.target.value)}
              />

              {/* <input type='submit' value='Login'/> */}
              <Button
                type='submit'
                variant='contained'
                sx={{ mt: 3, mb: 2, borderRadius: 3 }}
              >
                Sign Up
              </Button>
            </form>
          </Box>
        )}
        {signupshow && tabIndex === 1 && upstage === 2 && ( // tab for email verification
          <Box>
            <h1 style={{ fontSize: 50 }}>
              {user ? `User: ${user.attributes.email}` : 'Confirm '}
            </h1>
            <form onSubmit={handleconfirmsignup}>
              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                // size='small'
                label='Email'
                value={email}
                autoComplete='uasername'
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                fullWidth
                sx={{ py: 1 }}
                margin='normal'
                variant='outlined'
                // size='small'
                label='CODE'
                type='number'
                value={signupcode}
                autoComplete='Enter code'
                onChange={(e) => setSignupcode(e.target.value)}
              />
              {/* <input type='submit' value='Login'/> */}
              <Button
                type='submit'
                variant='contained'
                sx={{ mt: 3, mb: 2, borderRadius: 3 }}
              >
                Confirm signup
              </Button>
              <Button
                variant='contained'
                onClick={handleresendsignup}
                sx={{ mt: 3, mb: 2, borderRadius: 3 }}
              >
                Resend code
              </Button>
            </form>
          </Box>
        )}
        { ((!signupshow && tabIndex === 1 && stage === 1) || (signupshow && tabIndex === 2 && stage === 1)) && (
        <Box>
          <h1 style={{ fontSize: 50 }}>
            {user
              ? `User: ${user.attributes.email}`
              : 'Forget your Password'}
          </h1>
          <form onSubmit={sendCode}>
            <TextField
              fullWidth
              sx={{ py: 1 }}
              margin='normal'
              variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                  // size='small'
              label='Email'
              value={email}
              autoComplete='username'
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* <input type='submit' value='Login'/> */}
            <Button
              type='submit'
              variant='contained'
              sx={{ mt: 3, mb: 2, borderRadius: 3 }}
            >
              Send recovery email
            </Button>
          </form>
        </Box>
        )}
        { ((!signupshow && tabIndex === 1
          && stage === 2) || (signupshow && tabIndex === 2
          && stage === 2)) && ( // tab for password recovery
            <Box>
              <h1 style={{ fontSize: 50 }}>
                {user
                  ? `User: ${user.attributes.email}`
                  : 'Change Your Password'}
              </h1>
              <form onSubmit={resetPassword}>
                <TextField
                  fullWidth
                  sx={{ py: 1 }}
                  margin='normal'
                  variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                  // size='small'
                  label='Email'
                  value={email}
                  autoComplete='username'
                  onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                  fullWidth
                  sx={{ py: 1 }}
                  margin='normal'
                  variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                  // size='small'
                  label='Enter your Code'
                  type='number'
                  value={code}
                  autoComplete='code'
                  onChange={(e) => setCode(e.target.value)}
                />
                <TextField
                  fullWidth
                  sx={{ py: 1 }}
                  margin='normal'
                  variant='outlined' // WHEN WE HOOVER THERE IS OUTLINE ON BOX
                  // size='small'
                  label='Enter your password'
                  value={password}
                  autoComplete='password'
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      (!isEdgeBrowser && (
                        <IconButton onClick={handleShowPassword} aria-label='Toggle password visibility'>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      ))
                    ),
                  }}
                />

                {/* <input type='submit' value='Login'/> */}
                <Button
                  type='submit'
                  variant='contained'
                  sx={{ mt: 3, mb: 2, borderRadius: 3 }}
                >
                  Change password
                </Button>
              </form>
            </Box>
        )}
      </Box>
    </div>
  );
}
LoginForm.propTypes = {};
export default LoginForm;
